export default __webpack_public_path__ + "static/img7-bf4dd011432c51f4aa86f6ab473ea515.jpg";